import React, { useEffect, useRef, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Modal,
  Row,
  Typography,
  // FloatButton,
  Table,
  Spin,
  Skeleton,
  Tooltip,
} from "antd";
import { toast, ToastContainer } from "react-toastify";
import {
  ArrowLeftOutlined,
  // QuestionCircleOutlined,
  // BarcodeOutlined,
  DownloadOutlined,
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  PrinterFilled,
} from "@ant-design/icons";
import { isEmpty } from "lodash";
import { useHistory } from "react-router-dom";
import useBeforeUnload from "../../components/Prompting";
import "./index.css";
import useMedia from "use-media-antd-query";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import {
  loadPaymentInList,
} from "../../store/payment-in/actions";
import ReactToPrint from "react-to-print-advanced";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";
import api from "../../helpers";

const PaymentSelection = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const media = useMedia();
  const [loading, setLoading] = useState(false);

  //state values from list table
  const updatedPaymentData =
    props.location && props.location.state
      ? props.location.state.paymentData
      : "";

  //user details from login
  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const organizationId = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";
  const createdById = !isEmpty(userNameDetails) ? userNameDetails.user._id : "";

  //initial states
  const [paymentPrint, setPaymentPrint] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const paymentRef = useRef(null);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDownloadPDF = () => {
    const content = paymentRef.current;
    setDownloadLoading(true);
    setTimeout(() => {
      setDownloadLoading(false);
    }, 3000);

    // const padding = 40; // Padding in mm
    setTimeout(() => {
      html2canvas(content).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const imgWidth = 200;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        console.log(imgHeight, "imgHeight");
        pdf.addImage(imgData, "PNG", 2, 10, imgWidth, imgHeight);
        pdf.save("Payment-invoice.pdf");
      });
    }, 1200);
  };
  //header data

  const HeaderData = [
    {
      key: "siDate",
      title: <p className="header-sales-invoice font-semibold">Date</p>,
      dataIndex: "siDate",
    },
    {
      key: "invoiceNumber",
      title: <p className="header-sales-invoice font-semibold">Invoice No</p>,
      dataIndex: "invoiceNumber",
    },
    {
      key: "invoiceAmount",
      title: <p className="header-sales-invoice font-semibold">Amount</p>,
      dataIndex: "invoiceAmount",
    },
    {
      key: "amountSettled",
      title: (
        <p className="header-sales-invoice font-semibold">
          Invoice Amount Settled
        </p>
      ),
      dataIndex: "amountSettled",
    },
  ];

  const paymentPreviewData =
    updatedPaymentData && updatedPaymentData.salesInvoices.length > 0
      ? updatedPaymentData.salesInvoices.map((data) => {
          return {
            amountSettled: (
              <div className="flex">
                <p>{"₹ "}</p>
                <p style={{ fontFamily: "Poppins", marginLeft: "3px" }}>
                  {data.amountSettled &&
                    parseFloat(data.amountSettled).toFixed(2)}
                </p>
              </div>
            ),
            dueDate: moment(data.dueDate).format("DD-MM-YYYY"),
            invoiceAmount: (
              <div className="flex">
                <p>{"₹ "}</p>
                <p style={{ fontFamily: "Poppins", marginLeft: "3px" }}>
                  {data.invoiceAmount &&
                    parseFloat(data.invoiceAmount).toFixed(2)}
                </p>
              </div>
            ),
            invoiceNumber: (
              <p style={{ fontFamily: "Poppins" }}>{data.invoiceNumber}</p>
            ),
            invoicePendingAmount: "₹ " + data.invoicePendingAmount,
            siDate: (
              <p style={{ fontFamily: "Poppins" }}>
                {moment(data.siDate).format("DD-MM-YYYY")}
              </p>
            ),
            siId: data.siId,
            _id: data._id,
          };
        })
      : [];

  //payment settles options

  const [deletePaymentInModal, setDeletePaymentInModal] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  //deletPurchase api integrations
  const deletePaymentInApi = () => {
    setIsButtonDisabled(true);
    setTimeout(() => {
      setIsButtonDisabled(false);
    }, 4000);
    const itemListData = {
      organizationId: organizationId,
      paymentInId: updatedPaymentData._id,
      deletedBy: createdById,
    };
    api
      .post("/org/deletePaymentIn", itemListData)
      .then((res) => {
        dispatch(
          loadPaymentInList({
            organizationId: organizationId,
          })
        );
        setDeletePaymentInModal(false);
        toast.error("Payment In deleted successfully");
        setTimeout(() => {
          history.push("/payment-in");
        }, 1200);
        return res.data;
      })
      .catch((error) => {
        const errorMsg =
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.error) ||
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.message);
        toast.error(errorMsg || "There is an issue while delete the payment");
        Promise.reject(error);
      });
    // dispatch(deletePaymentInList(itemListData));
  };

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  console.log(updatedPaymentData, "updatedPaymentData");
  //onload
  useBeforeUnload({
    when:
      updatedPaymentData !== undefined && !isEmpty(updatedPaymentData.partyId),
    message: "Are you sure you want to leave?",
  });
  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Create Payment In | Mbook</title>
        </MetaTags>
      </div>

      <Row>
        <Col
          span={24}
          className="border border-b-1 border-t-0 border-x-0 pb-3 rounded-sm bg-[#ffffff]"
        >
          <div className="font-poppins flex justify-between pl-[20px] pr-[20px] mt-4">
            <div
              className="flex"
              style={{
                fontFamily: "Poppins",
              }}
            >
              <ArrowLeftOutlined
                onClick={() => {
                  history.push("/payment-in");
                }}
                className="font-bold text-[18px]"
              />
              <h1 className="text-[18px] ml-2 mt-1 font-semibold">
                Payment In
                {/* Payment In # {updatedPaymentData && updatedPaymentData.} */}
              </h1>
            </div>
            <div className="flex">
              <Tooltip
                title="Edit Purchase Invoice"
                placement="left"
                rootClassName="text-[10px]"
              >
                <div
                  onClick={() => {
                    history.push({
                      pathname: "/create-payment-in",
                      state: {
                        paymentData: updatedPaymentData
                          ? updatedPaymentData
                          : "",
                        organizationId: organizationId,
                        userId: createdById,
                      },
                    });
                  }}
                  className="cursor-pointer border flex rounded-md justify-between  pl-3 pr-2 pt-1 pb-1 ml-3  cursor-pointer"
                >
                  <EditOutlined className="text-[18px] pr-2" /> Edit
                </div>
              </Tooltip>
              <Tooltip
                title="Delete This Payment Details"
                placement="bottom"
                rootClassName="text-[10px]"
              >
                <div
                  onClick={() => setDeletePaymentInModal(true)}
                  className="border border-1 border-red-200 text-[red] rounded-md ml-3 pl-3 pr-3 pt-1 pb-1 cursor-pointer"
                >
                  <DeleteOutlined />
                </div>
              </Tooltip>
            </div>
          </div>
        </Col>
        <Col span={24} className="pl-4 pt-4 pb-4 pr-1 bg-[#ffffff]">
          <Row>
            <Col span={20}>
              <Row>
                <Col md={8} lg={6} sm={12} xs={24} className="pr-4">
                  {loading ? (
                    <Skeleton.Input className="w-[100%]"></Skeleton.Input>
                  ) : (
                    <div
                      style={{
                        fontFamily: "Poppins",
                      }}
                      onClick={handleDownloadPDF}
                      className="cursor-pointer flex border pt-2 pb-2 pl-2 pr-4 rounded-md border-1 track-wider text-start lg:text-center xl:text-center"
                    >
                      {downloadLoading ? (
                        <p className="flex">
                          <Spin className="mr-2" /> Downloading
                        </p>
                      ) : (
                        <div className="flex">
                          <DownloadOutlined className="text-[16px] mr-3" />{" "}
                          Download
                        </div>
                      )}
                    </div>
                  )}
                </Col>
                <Col md={8} lg={6} sm={12} xs={24} className="pr-4 pl-4">
                  {loading ? (
                    <Skeleton.Input className="w-[100%]"></Skeleton.Input>
                  ) : (
                    <div
                      className="cursor-pointer w-[100%]"
                      onClick={() => {
                        setPaymentPrint(true);
                        setTimeout(() => {
                          setPaymentPrint(false);
                        }, 4000);
                      }}
                    >
                      <ReactToPrint
                        trigger={() => (
                          <div
                            style={{
                              fontFamily: "Poppins",
                            }}
                            className="track-wider flex border pt-2 pb-2 pl-2 pr-4 rounded-md border-1 text-start lg:text-center xl:text-center"
                          >
                            {paymentPrint ? (
                              <p className="flex">
                                <Spin className="mr-2" /> Loading
                              </p>
                            ) : (
                              <div className="flex">
                                <PrinterFilled className="cursor-pointer text-[16px] mr-3" />
                                Print Receipt
                              </div>
                            )}
                          </div>
                        )}
                        delay={1500}
                        content={() => paymentRef.current}
                      />
                    </div>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col
          md={24}
          xl={24}
          xxl={24}
          sm={24}
          xs={24}
          className={
            (windowDimensions.height >= 700 &&
              windowDimensions.height <= 767) ||
            (windowDimensions.height > 767 && windowDimensions.height < 830)
              ? "add-payment-in-preview-large-device pb-8"
              : windowDimensions.height > 830
              ? "add-payment-in-preview-extra-large-device pb-8"
              : "add-payment-in-preview pb-8"
          }
          style={{
            background: downloadLoading ? "#ffffff" : "#ffffff",
            width: "100%",
          }}
        >
          <Row
            // id="pdf-content"
            ref={paymentRef}
            style={{
              paddingTop: paymentPrint ? "30px" : "0px",
              paddingRight: downloadLoading ? "10px" : "",
              background: paymentPrint ? "#ffffff" : "",
            }}
          >
            <Col
              md={24}
              xl={24}
              xxl={24}
              sm={24}
              xs={24}
              className={"pl-4 pr-4 pt-3 bg-[#ffffff]"}
            >
              <Row className="border border-solid border-1 rounded-md pb-4">
                <Col
                  md={24}
                  xl={24}
                  xxl={24}
                  sm={24}
                  xs={24}
                  className="pl-5 pt-2 pb-2 mb-2 bg-[#efefef] border border-b-1 border-t-0 border-x-0"
                >
                  <h1
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="text-[14px] font-semibold"
                  >
                    Payment Details
                  </h1>
                </Col>
                <Col
                  md={8}
                  sm={12}
                  lg={8}
                  xs={12}
                  className="pr-4 pl-4 pt-2 pb-2"
                >
                  <Typography className="input-payment-in-selected-label mb-[5px]">
                    Party Name
                  </Typography>
                  <h1
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="text-[12px] font-semibold"
                  >
                    {updatedPaymentData && updatedPaymentData.partyName
                      ? updatedPaymentData.partyName
                      : "--"}
                  </h1>
                </Col>
                <Col
                  md={8}
                  sm={12}
                  lg={8}
                  xs={12}
                  className="pr-4 pl-4 pt-2 pb-2"
                >
                  <Typography className="input-payment-in-selected-label mb-[5px]">
                    Payment Date
                  </Typography>
                  <h1
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="text-[12px] font-semibold"
                  >
                    {updatedPaymentData && updatedPaymentData.paymentDate
                      ? moment(updatedPaymentData.paymentDate).format(
                          "DD-MM-YYYY"
                        )
                      : "--"}
                  </h1>
                </Col>
                <Col
                  md={8}
                  sm={12}
                  lg={8}
                  xs={12}
                  className="pr-4 pl-4 pt-2 pb-2"
                >
                  <Typography className="input-payment-in-selected-label mb-[5px]">
                    Payment Amount
                  </Typography>
                  <h1
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="text-[12px] font-semibold"
                  >
                    {updatedPaymentData && updatedPaymentData.enterPaymentAmount
                      ? parseFloat(
                          updatedPaymentData.enterPaymentAmount
                        ).toFixed(2)
                      : "--"}
                  </h1>
                </Col>
                <Col
                  md={8}
                  sm={12}
                  lg={8}
                  xs={12}
                  className="pr-4 pl-4 pt-2 pb-2"
                >
                  <Typography className="input-payment-in-selected-label mb-[5px]">
                    Payment Mode
                  </Typography>
                  <h1
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="text-[12px] font-semibold"
                  >
                    {updatedPaymentData && updatedPaymentData.paymentModeName
                      ? updatedPaymentData.paymentModeName
                      : "--"}
                  </h1>
                </Col>
                {/* {!isEmpty(paymentMode) &&
                paymentMode !== "66c9bd5ab3fca462ca48a87e" ? ( */}
                <Col
                  md={8}
                  sm={12}
                  lg={8}
                  xs={12}
                  className="pr-4 pl-4 pt-2 pb-2"
                >
                  <Typography className="input-payment-in-selected-label mb-[5px]">
                    Account
                  </Typography>
                  {updatedPaymentData && updatedPaymentData.accountDetails ? (
                    <h1
                      style={{
                        fontFamily: "Poppins",
                      }}
                      className="text-[12px] font-semibold"
                    >
                      {updatedPaymentData && updatedPaymentData.accountDetails
                        ? updatedPaymentData.accountDetails.accountName
                        : ""}{" "}
                      (
                      {updatedPaymentData && updatedPaymentData.accountDetails
                        ? updatedPaymentData.accountDetails.accountNumber
                        : ""}
                      )
                    </h1>
                  ) : (
                    "--"
                  )}
                </Col>
                {/* ) : (
                  ""
                )} */}

                <Col
                  md={8}
                  xl={8}
                  xxl={8}
                  sm={12}
                  xs={12}
                  className="pr-4 pl-4 pt-2 pb-2"
                >
                  <Typography className="input-payment-in-selected-label mb-1">
                    Notes
                  </Typography>
                  <h1
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="text-[12px] font-semibold"
                  >
                    {updatedPaymentData && updatedPaymentData.notes
                      ? updatedPaymentData.notes
                      : "--"}
                  </h1>
                </Col>
              </Row>
            </Col>
            <Col
              md={24}
              xl={24}
              xxl={24}
              sm={24}
              xs={24}
              className={"pr-4 pl-4 bg-[white] pb-10"}
            >
              <Row className="mt-4 border border-solid border-1 rounded-md">
                <Col md={24} xl={24} xxl={24} sm={24} xs={24} className="">
                  <Row
                    className={
                      downloadLoading
                        ? "pl-4 pt-3 pb-4"
                        : paymentPrint
                        ? "pl-4 pt-3 pb-8"
                        : "pl-4 pt-3 pb-2"
                    }
                  >
                    <div>
                      <div
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="mr-4 pt-1 text-[14px] font-semibold"
                      >
                        Invoice Settled with this payment
                      </div>
                    </div>
                  </Row>
                </Col>
                <Col
                  md={24}
                  xl={24}
                  xxl={24}
                  sm={24}
                  xs={24}
                  className={
                    media === "xxl"
                      ? "pt-12 sales-invoice-orders"
                      : media === "md"
                      ? "pt-3 sales-invoice-orders"
                      : "pt-5 sales-invoice-orders"
                  }
                >
                  <Table
                    style={{
                      overflow: "hidden",
                    }}
                    bordered
                    columns={HeaderData}
                    dataSource={
                      paymentPreviewData && paymentPreviewData.length > 0
                        ? paymentPreviewData
                        : []
                    }
                    pagination={false}
                    rowClassName={"text-[12px]"}
                    // loading={tableLoading ? true : false}
                    // scroll={{ x: 765 }}
                    // scroll={{ y: 200, x: 765 }}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>

        {/* //delete modal */}
        <Modal
          open={deletePaymentInModal}
          onOk={() => {
            deletePaymentInApi();
          }}
          closeIcon
          maskClosable={false}
          okText={`Delete ${
            "" // selectedRowKeys.length > 0 ? selectedRowKeys.length : ""
          } Payment`}
          cancelText={"Cancel"}
          okType="danger"
          okButtonProps={{
            disabled: isButtonDisabled ? true : false,
          }}
          onCancel={() => setDeletePaymentInModal(false)}
          height={300}
          footer={(_, { OkBtn, CancelBtn }) => (
            <div className="text-center flex justify-center">
              <CancelBtn />
              <div className="ml-3">
                <OkBtn />
              </div>
            </div>
          )}
        >
          <div className="text-center w-[100%] p-7">
            <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
            <h1 className="text-center text-[18px] font-bold">
              Are you sure you want to delete these Payment In?
            </h1>
            <p className="text-center text-[14px] mt-2">
              The selected Payment In will be deleted from the Payment In
              Inventory. Once deleted you will not be able to restore these
              sales invoice.
            </p>
          </div>
        </Modal>
      </Row>

      {/* <Prompt
        when={!isEmpty(paymentInData.paymentInNo)}
        message="Are you sure you want to leave?"
      /> */}
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};

PaymentSelection.propTypes = {
  location: PropTypes.any,
};

export default PaymentSelection;
